export default {
    methods: {
        createUrlFromFile(file) {
            let url = ''
            if (file['content']) {
                const binaryString = atob(file['content'])
                const len = binaryString.length
                const bytes = new Uint8Array(len)

                for (let i = 0; i < len; i++) {
                    bytes[i] = binaryString.charCodeAt(i)
                }
                const blob = new Blob([bytes], { type: file['mime'] })

                url = URL.createObjectURL(blob)
            }

            return { url: url, name: file['name'] }
        },

        // Returns the hue of a #RRGGBB color, or null for invalid colors
        hueFromHex(hex) {
            const value = parseInt(hex.slice(1), 16)
            const red = (value >> 16) & 255
            const green = (value >> 8) & 255
            const blue = value & 255
            const max = Math.max(red, green, blue)
            const delta = max - Math.min(red, green, blue)
            let hue = null

            if (hex.length === 7 && delta > 0) {
                hue =
                    max === red
                        ? (60 * ((green - blue) / delta) + 360) % 360
                        : max === green
                          ? 60 * ((blue - red) / delta) + 120
                          : 60 * ((red - green) / delta) + 240
            }

            return hue
        },
    },
}
